export default "__VITE_ASSET__CPO8k7tM__"